<template>
  <v-container fluid class="marketproject-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="12" lg="12" class="d-flex justify-space-between justify-md-start overflow-auto">
              <v-btn to="/marketproject/add" color="success" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
              <v-btn color="success" class="button-shadow mr-2" @click="findMarketProjectDialog=true">
                <v-icon class="mr-2">mdi-file-search</v-icon>
                Find
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              show-select
              sort-by="projectnum"
              item-key="_id"
              loading-text="Loading... Please wait"
              class="marketprojects-table"
              :loading="isReceiving || isDeleting"
              :footer-props="footer"
              :headers="header_project"
              :items="projects"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Marketing Project?
                    </v-card-title>
                    <v-card-text>
                      {{ delete_project.projectnum }} 
                      {{ delete_project.projectname }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(delete_project)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.repid="{ item }">
                <div v-if="item.repid!=undefined">
                  <p class="two-line" style="margin-left: 15px;">
                    <v-avatar v-if="item.repimage!=null" size="40">
                      <img v-bind:src="item.repimage" alt="">
                    </v-avatar>
                    <v-avatar
                      v-else
                      color="warning"
                      size="40">
                      <p v-if="item.repname.length>0" class="two-line"><span class="white--text headline">{{ item.repname[0].toUpperCase() }}</span></p>
                    </v-avatar>
                  </p>
                  <p class="two-line"><span style="margin-left:15px">{{ item.repname }} </span></p>
                  <p class="two-line"><span style="margin-left:15px; font-size: 9pt;">{{ item.rep_companycode }} </span></p>
                </div>
              </template>
              <template v-slot:item.approverid="{ item }">
                <div v-if="item.approverid!=undefined">
                  <p class="two-line" style="margin-left: 15px;">
                    <v-avatar v-if="item.approverimage!=null" size="40">
                      <img v-bind:src="item.approverimage" alt="">
                    </v-avatar>
                    <!-- <v-avatar
                      v-else
                      color="warning"
                      size="40">
                      <p v-if="item.approvername.length>0" class="two-line"><span class="white--text headline">{{ item.approvername[0].toUpperCase() }}</span></p>
                    </v-avatar> -->
                  </p>
                <p class="two-line"><span style="margin-left:15px">{{ item.approvername }} </span></p>
                <p class="two-line"><span style="margin-left:15px; font-size: 9pt;">{{ item.approver_companycode }} </span></p>
                </div>
              </template>
              <template v-slot:item.projectimage="{ item }">
                    <v-img
                    v-if="item.projectimage" 
                    v-bind:src="item.projectimage"
                    max-height="70"
                    max-width="70"
                  ></v-img>
              </template>
              <template v-slot:item.projectnum="{ item }">
                <p class="two-line" style="font-weight: 600;">Project #{{ item.projectnum  }}</p>
                <p class="two-line" style="font-weight: 600;">{{ item.mktprojectname }}</p>
                <p class="two-line">{{ item.projecttype  }}</p>
                <p class="two-line" style="font-size: 10pt;">{{ item.projectname }}</p>
                <p class="two-line">{{ new Date(item.projectdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</p>
                <p v-if="item.marketprojectdate!=undefined" class="two-line">{{ new Date(item.marketprojectdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' })  }}</p>
              </template>
              <template v-slot:item.projectname="{ item }">
                <p class="two-line">{{ item.projectname }}</p>
              </template>
              <template v-slot:item.contents="{ item }">
                {{ item.count_content }}
              </template>
              <template v-slot:item.posts="{ item }">
                {{ item.count_post }}
              </template>
              <template v-slot:item.adsets="{ item }">
                {{ item.count_adset }}
              </template>
              <template v-slot:item.projectstatus="{ item }">
                <v-chip
                  v-if="item.projectstatus!=undefined"
                  :color="getStatusColor(item.projectstatus)" small>
                  {{ item.projectstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <div v-if="item._id!=undefined">
                  <v-tooltip bottom>
                    <template #activator="{ on }">
                      <v-btn icon v-on="on" color="primary" @click="manageProjectDigital(item)">
                        <v-icon>mdi-folder-star-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Digital</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template #activator="{ on }">
                      <v-btn icon v-on="on" color="primary" @click="manageProjectTraditional(item)">
                        <v-icon>mdi-folder-heart-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Traditional</span>
                  </v-tooltip>
                  <v-btn icon color="primary" @click="editItem(item)">
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                <!-- <v-btn icon color="primary" @click="printItem(item)">
                  <v-icon>mdi-printer</v-icon>
                </v-btn> -->
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <div>
    <v-dialog
      v-model="findMarketProjectDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Find Marketing Projects</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-select
                  :items="townships.filter(x=>x.townshipstatus=='Active').map(x => {
                            return {text: x.townshipname, value: x._id};
                          })"
                  v-model="query.townshipid"
                  label="Township"
                  required
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-select
                  :items="paymethods.filter(x=>x.paymethodstatus=='Active').map(x => {
                            return {text: x.paymethodname, value: x._id};
                          })"
                  v-model="query.paymethodid"
                  label="Payment Method"
                  required
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-select
                  :items="users.filter(x=>x.userstatus=='Active').map(x => {
                            return {text: x.username, value: x._id};
                          })"
                  v-model="query.userid"
                  label="Sales Rep"
                  required
                ></v-select>
              </v-col>

              <v-col cols="12" sm="6" md="6">
                        <v-menu
                          ref="menu_startdate"
                          v-model="menu_startdate"
                          :close-on-content-click="false"
                          :return-value.sync="query.startdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="query.startdate"
                              label="Start Date"
                              v-bind="attrs"
                              v-bind:value="query.startdate"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please enter start date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="query.startdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_startdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_startdate.save(query.startdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                        <v-menu
                          ref="menu_enddate"
                          v-model="menu_enddate"
                          :close-on-content-click="false"
                          :return-value.sync="query.enddate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="query.enddate"
                              label="End Date"
                              v-bind="attrs"
                              v-bind:value="query.enddate"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please enter end date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="query.enddate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_enddate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_enddate.save(query.enddate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="findMarketProjectDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="resetMarketProjects"
          >
            Reset
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="findMarketProjects"
          >
            Find
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  </v-container>
</template>

<script>
import config from "../../../../config"
import { mapState, mapActions } from 'vuex'
import { getStatusColor } from '@/util/tools';

export default {
  name: 'MarketProjectList',
  data() {
    return {
      config,
      findMarketProjectDialog: false,
      menu_startdate: null,
      menu_enddate: null,
      itemPerPage: 500,
      delete_project: {},
      query: {},
      footer: {'items-per-page-options': [500, 1000, 5000]},
      header_project: [
        { text: 'Image', value: 'projectimage', sortable: false, width: "5%" },
        { text: 'Type', value: 'projectnum', sortable: false },
        { text: 'Cnt', value: 'contents', sortable: false, width: "4%"},
        { text: 'Pst', value: 'posts', sortable: false, width: "4%"},
        { text: 'Ads', value: 'adsets', sortable: false, width: "4%"},
        { text: 'Marketing Rep', value: 'repid' , width: "12%" },
        { text: 'Approver', value: 'approverid' , width: "12%" },
        { text: 'Status', value: 'projectstatus' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      dataSelected: [],
      getStatusColor: getStatusColor,
    }
  },
  computed: {
    ...mapState('MarketProject', ['projects', 'isReceiving', 'isDeleting', 'idToDelete', 'marketprojectsMessage', 'isUpdating']),
    ...mapState('PayMethod', ['paymethods']),
    ...mapState('Region', ['regions']),
    ...mapState('Township', ['townships']),
    ...mapState('User', ['users']),
  },
  methods: {
    ...mapActions('MarketProject', ["getMarketProjectsTeamRequest", "getMarketProjectQueryRequest", "deleteMarketProjectRequest","updateMarketProjectRequest","createMarketProjectRequest"]),
    ...mapActions('PayMethod', ["getPayMethodsRequest"]),
    ...mapActions('Region', ["getRegionsRequest"]),
    ...mapActions('Township', ["getTownshipsRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    getJson(){
      let json = this.projects.map(order=>{return {
        ordernum: order.projectnum, 
        orderdate: order.marketprojectdate!=undefined ? new Date(order.marketprojectdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '',
        ordertime: order.marketprojectdate!=undefined ? new Date(order.marketprojectdate).toLocaleString("en-SG", { hour: 'numeric', minute: 'numeric' }) : '',
        ordertype: order.projecttype,
        name: order.projectname, 
        address: order.marketprojectaddress,
        region: order.regionid!=undefined && this.regions.length>0 ? this.regions.find(region=>region._id == order.regionid)['regionname'] : '',
        township: order.townshipid!=undefined && this.townships.length>0 ? this.townships.find(town=>town._id == order.townshipid)['townshipname'] : '',
        customertype: order.customertype,
        salesrep: order.userid!=undefined && this.users.length>0 ? this.users.find(user=>user._id == order.userid)['username'] : '',
        paymentmethod: order.paymethodid!=undefined && this.paymethods.length>0 ? this.paymethods.find(method=>method._id == order.paymethodid)['paymethodname'] : '',
        tax: order.marketprojecttaxamount,
        subtotal: order.marketprojectsubtotal,
        total: order.marketprojecttotal,
        rate: order.currencyRate,
      }});
      return json;
    },
    checkError(){
      if(this.dataSelected.length==0) return false;
      if(this.dataSelected.find(item=>item.projectstatus=='Completed')!=null) return false;
      return true;
    },
    checkMarketProjects(){
      return this.dataSelected.filter(item=>item.projectstatus=='Completed').map(item=>item.projectnum.toString()).join(', ');
    },
    getFileName(){
      var d = new Date();
      var name = 'sales-orders-' + d.getFullYear() + '-' + (d.getMonth()+1).toString() + '-' + d.getDate() + '-' + (d.getHours().toString() +d.getSeconds().toString());
      return name + '.xls';
    },
    manageProjectDigital(item) {
      item['_isFrom'] = this.$route.name;
      if(this.$route.name=='MarketProjectTeamList') this.$router.push({ name: 'MarketProjectDigitalTeamManage', params: item });
      else this.$router.push({ name: 'MarketProjectDigitalManage', params: item });
    },
    manageProjectTraditional(item) {
      item['_isFrom'] = this.$route.name;
      this.$router.push({ name: 'MarketProjectTraditionalManage', params: item });
    },
    editItem(item) {
      item['_isFrom'] = this.$route.name;
      this.$router.push({ name: 'MarketProjectEdit', params: item });
    },
    printItem(item) {
      this.$router.push({ name: 'MarketProjectPrint', params: item });
    },
    viewItem(item) {
      this.$router.push({ name: 'MarketProjectView', params: item });
    },
    async findMarketProjects(){
      this.findMarketProjectDialog = false;
      if(this.query=={}){
        await this.getMarketProjectsTeamRequest();
        this.projects = Object.assign([], this.marketprojects);
        this.projects.push({marketprojecttotal: this.marketprojects.reduce(function (last, json) {return last + json.marketprojecttotal;}, 0) });
      }
      else{
        let result = await this.getMarketProjectQueryRequest(this.query);
        this.projects = Object.assign([], result);
        this.projects.push({marketprojecttotal: result.reduce(function (last, json) {return last + json.marketprojecttotal;}, 0) });
      }
    },
    async resetMarketProjects(){
      this.query = {};

    },
    async deleteItem(item) {
      await this.deleteMarketProjectRequest(item);
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.delete_project = {
        _id: item._id,
        projectnum: item.projectnum,
        projectname: item.projectname,
      }
    },
  },
  async created () {
    if(this.projects.length==0) await this.getMarketProjectsTeamRequest();
    console.log('1',this.projects)
    if(this.users.length==0) await this.getUsersRequest();
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
